import Skeleton from '@mui/material/Skeleton';
import { PulseAiIcon } from 'assets/images/icons';
import Avatar, { RemovedPersonAvatar } from '@components/Avatar';
import { useAccountPeople } from '@hooks';
import { getChannelIcon } from '@helpers/channels';
import { getFullName, getInitialsParts } from '@helpers/userName';
import { SenderType } from '@constants/inbox';

export const SENDER_AVATAR_SIZE = 24;

const pulseAvatar = <Avatar size="small" icon={<PulseAiIcon />} />;

const loadingAvatar = <Skeleton variant="circular" width={SENDER_AVATAR_SIZE} height={SENDER_AVATAR_SIZE} />;

const MessageSenderAvatar = ({ senderId, senderType, channel }) => {
    const { isLoaded, getPerson } = useAccountPeople();

    if (senderType === SenderType.Bot) {
        return pulseAvatar;
    }

    if (senderType === SenderType.External) {
        return <Avatar size="small" icon={getChannelIcon(channel)} sx={{ backgroundColor: 'var(--action-hover)' }} />;
    }

    if (senderId) {
        if (!isLoaded) {
            return loadingAvatar;
        }
        const person = getPerson(senderId);
        if (person && !person.isRemoved) {
            return (
                <Avatar
                    size="small"
                    image={person.profileImageUrl}
                    label={getInitialsParts(person.firstName, person.lastName)}
                    fullName={getFullName(person.firstName, person.lastName)}
                />
            );
        }
    }

    return <RemovedPersonAvatar size="small" />;
};

export default MessageSenderAvatar;
